'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

import Loading from '@/legacy/components/feature/Loading';
import { determineLocale } from '@/lib/determineLocale';

const Home = () => {
	const router = useRouter();

	useEffect(() => {
		const locale = determineLocale();
		router.replace(`/${locale}`);
	}, []);

	return <Loading />;
};
export default Home;
